import '../sass/app.scss';
import { runLegacyApp } from './app-old.js';

import './bootstrap';

import { createApp } from 'vue/dist/vue.esm-bundler';
import { createPinia, mapStores } from 'pinia';

import App from './App.vue';
import Validator from './components/Freeform/Validator.vue';

import router from './router';
import { useUserStore } from './stores/user';

const pinia = createPinia();
const app = createApp({
	data() {
		return {
			
		}
	},
	computed: {
		...mapStores(useUserStore)
	},
	methods: {
	},
	components: {
		"App" : App,
		Validator
    },
	mounted() {
		runLegacyApp();
	},
    delimiters: ['{:', ':}']
});

app.use(pinia);
app.use(router);
app.mount('#app');